import BaseApiService from './api.base.service'

class trainingProductsApiService extends BaseApiService {
  constructor() {
    super('training-products')
  }

  getCustomerTrainingProducts() {
    return this.callGet(`/customer-list`)
  }

  getElearningCustomerTrainingProducts() {
    return this.callGet(`/elearning-customer-list`)
  }

  getCoursesCustomerTrainingProducts() {
    return this.callGet(`/courses-customer-list`)
  }

  getMembershipsCustomerTrainingProducts() {
    return this.callGet(`/memberships-customer-list`)
  }

  getUserTrainingProductsOdata(params) {
    return this.callGet(`/user-list/odata`, params)
  }

  getActivatedTrainingProducts() {
    return this.callGet(`/activation-user-list`)
  }

  getTeachingMaterial(sessionParams) {
    return this.callPost(`/teaching-material/`, sessionParams)
  }

  getClassroomMaterial(dayId, siteId, sourceRequest) {
    return this.callGet(
      `/classroom-material/` + dayId + `/` + siteId + `/` + sourceRequest
    )
  }

  getEcQuestionsServiceAccess(courseId, siteId) {
    return this.callPost(`/ec-questions/access`, { courseId, siteId })
  }
}

export const trainingProductsApi = new trainingProductsApiService()
